<template lang="html">
  <div class="ai-pagination">
    <div class="ai-pagination-pages">
      <div class="ai-button ai-button--icon-only"
           :class="{'ai-button--disabled': value === 1}"
           @click="pageUp">
        <img src="./page_up.svg">
      </div>
      <div v-if="paginationRange[0].length" class="ai-pagination-pages__overflow">
        <div v-for="n in paginationRange[0]"
             :key="n"
             class="ai-button"
             @click="jumpTo(n)">
          {{ n }}
        </div>
        <img src="@/assets/components/pagination-more.svg">
      </div>
      <div v-for="n in paginationRange[1]"
           :key="n"
           class="ai-button"
           :class="{'ai-button--primary': n === value}"
           @click="jumpTo(n)">
        {{ n }}
      </div>
      <div v-if="paginationRange[2].length" class="ai-pagination-pages__overflow">
        <img src="@/assets/components/pagination-more.svg">
        <div v-for="n in paginationRange[2]"
             :key="n"
             class="ai-button"
             @click="jumpTo(n)">
          {{ n }}
        </div>
      </div>
      <div class="ai-button ai-button--icon-only"
           :class="{'ai-button--disabled': value === totalPageCount}"
           @click="pageDown">
        <img src="./page_down.svg">
      </div>
    </div>
    <div class="ai-pagination-jump">
      <span>跳至</span>
      <AiInput :value="value" type="number" @input="jumpTo" />
      <span>页</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiPagination',
  props: {
    totalPageCount: {
      type: Number,
      default: 1
    },
    value: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      paginationRange: [[], [], []]
    };
  },
  computed: {},
  watch: {
    value(newVal) {
      let val = newVal;
      if (newVal > this.totalPageCount) val = this.totalPageCount;
      else if (newVal < 1) val = 1;
      this.calcPaginationRange();
      this.$emit('input', val);
      this.$emit('change');
    },
    totalPageCount() {
      this.calcPaginationRange();
      this.$emit('input', this.value);
    }
  },
  mounted() {
    this.calcPaginationRange();
  },
  methods: {
    jumpTo(index) {
      this.$emit('input', index);
    },
    pageUp() {
      this.jumpTo(this.value - 1);
    },
    pageDown() {
      this.jumpTo(this.value + 1);
    },
    calcPaginationRange() {
      const result = [[], [], []];
      const total = this.totalPageCount;
      const current = this.value;

      if (total < 10) {
        for (let i = 1; i <= total; i += 1) {
          result[1].push(i);
        }
        this.paginationRange = result;
        return;
      }

      for (let i = current - 2; i <= current + 2; i += 1) {
        if (i > 0 && i <= total) result[1].push(i);
      }

      if (result[1][0] !== 1) {
        result[0].push(1);
      }

      if (result[1][result[1].length - 1] !== total) {
        result[2].push(total);
      }

      if (result[1][0] === 1) {
        const remain = 9 - result[1].length - 2;
        const base = result[1][result[1].length - 1];
        for (let i = 1; i <= remain; i += 1) {
          result[1].push(base + i);
        }
      }

      if (result[1][result[1].length - 1] === total) {
        const remain = 9 - result[1].length - 2;
        const base = result[1][0];
        for (let i = 1; i <= remain; i += 1) {
          result[1].unshift(base - i);
        }
      }

      this.paginationRange = result;
    }
  }
};
</script>
